var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1609_5773",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1609_5773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99984 2H11.3332V10.6667L6.6665 15.3333L5.83317 14.5C5.75539 14.4222 5.6915 14.3167 5.6415 14.1833C5.5915 14.05 5.5665 13.9222 5.5665 13.8V13.5667L6.29984 10.6667H1.99984C1.64428 10.6667 1.33317 10.5333 1.0665 10.2667C0.799837 10 0.666504 9.68889 0.666504 9.33333V8C0.666504 7.92222 0.677615 7.83889 0.699837 7.75C0.722059 7.66111 0.744282 7.57778 0.766504 7.5L2.7665 2.8C2.8665 2.57778 3.03317 2.38889 3.2665 2.23333C3.49984 2.07778 3.74428 2 3.99984 2ZM9.99984 3.33333H3.99984L1.99984 8V9.33333H7.99984L7.09984 13L9.99984 10.1V3.33333ZM11.3332 10.6667V9.33333H13.3332V3.33333H11.3332V2H14.6665V10.6667H11.3332Z",
    fill: "black",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumb_down.c4f08e90b4646a2eb56c9639ee281d8b.svg";
export { ForwardRef as ReactComponent };